import {
  createCorpHeadersMiddleware as withHeadersMiddleware,
  fetch as fetchBase,
} from '@logistics-frontend/core/utils/network'
import {pipe} from '@logistics-frontend/utils'

import {appConfig} from '../config'

type FetchFunction = typeof fetchBase
type PassportMiddlewareParams = {
  host: string
}

// пока что миддлвара будет жить тут, наверно до тех пока "auth" не начнет использовать сервис регистрации
function withPassportMiddleware({host}: PassportMiddlewareParams) {
  return function _withPassportMiddleware(fetchFn: FetchFunction): FetchFunction {
    return function passportFetch(config) {
      return fetchFn({
        ...config,
        url: `${host}${config.url}`,
        options: {
          credentials: 'include',
        },
      })
    }
  }
}

function withAccountRedirectMiddleware(fetchFn: FetchFunction): FetchFunction {
  return function _withAccountRedirectMiddleware(config) {
    return fetchFn(config).catch(error => {
      if (error.status === 410) {
        window.location.href = appConfig.accountUrl
        return error
      }
      throw error
    })
  }
}

export const fetch = pipe(
  fetchBase,
  withAccountRedirectMiddleware,
  withHeadersMiddleware({
    version: appConfig.version,
    lang: appConfig.lang,
    getURI() {
      return `${window.location.origin}${window.location.pathname}`
    },
  }),
) as FetchFunction

export const passportFetch = pipe(
  fetchBase,
  withPassportMiddleware({
    host: appConfig.passportApiHost,
  }),
) as FetchFunction
